module.exports = __webpack_public_path__ + "img/d20190322_3.22a32444.jpg";